import LinkifyMultipleText from "@components/UI/atoms/LinkifyMultipleText";
import CircularLoading from "@components/UI/organisms/CircularLoading/CircularLoading";
import { ModalOpenParams } from "@containers/SuperOwner/LearningTemplatePackages/LearningTemplateListContainer";
import {
  LearningTemplatePackageBase,
  PackagingAsLearningTemplatePackageBase,
} from "@lib/Api";
import {
  Box,
  Collapse,
  Container,
  Divider,
  TableCell,
  TableRow,
} from "@mui/material";
import { SuperOwnerAppLearningTemplatePackagesState } from "@reducers/superOwnerApp/templatePackages/learningTemplatePackage";

import ActionButtons from "../ActionButtons";
import { PackagesComponent } from "../Package/packages.component";
import { useStyles } from "../style";
import { usePackageListView } from "./package-list.view";

type Props = {
  openModule: boolean;
  handleModalOpen: (modalOpenParams: ModalOpenParams) => void;
  learningTemplate: LearningTemplatePackageBase;
  packages: PackagingAsLearningTemplatePackageBase[];
  isLoading: boolean;
  isSuccess: boolean;
  refetch: () => void;
  packagesArray: PackagingAsLearningTemplatePackageBase[];
  learningTemplateCache: SuperOwnerAppLearningTemplatePackagesState;
};

export const PackageListComponent = ({
  openModule,
  learningTemplate,
  packages,
  isLoading,
  isSuccess,
  refetch,
  packagesArray,
  handleModalOpen,
  learningTemplateCache,
}: Props) => {
  const classes = useStyles();
  const {
    onDragEnd,
    reorderPackageList,
    isSorting,
    isHasReorderPackageList,
    handleActivateSort,
    handleDeactivateSort,
  } = usePackageListView({
    learningTemplate,
    packages,
    isSuccess,
    refetch,
    learningTemplateCache,
  });

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
        <Collapse in={openModule} timeout="auto" unmountOnExit>
          <Container sx={classes.packagesWrapper}>
            {learningTemplate.description ? (
              <>
                <LinkifyMultipleText text={learningTemplate.description} />
                <Divider sx={classes.dividerRoot} />
              </>
            ) : null}
            <Box>
              {isLoading ? (
                <Box style={{ width: "100%", height: "250" }}>
                  <CircularLoading />
                </Box>
              ) : (
                <PackagesComponent
                  onDragEnd={onDragEnd}
                  reorderPackageList={reorderPackageList}
                  handleModalOpen={handleModalOpen}
                  learningTemplate={learningTemplate}
                  packagesArray={packagesArray}
                  isSorting={isSorting}
                />
              )}
            </Box>
            <Divider sx={classes.divider} />
            <ActionButtons
              learningTemplate={learningTemplate}
              packagesArray={packagesArray}
              isSorting={isSorting}
              handleModalOpen={handleModalOpen}
              handleActivateSort={handleActivateSort}
              handleDeactivateSort={handleDeactivateSort}
              isHasReorderPackageList={isHasReorderPackageList}
            />
          </Container>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
